import { Component, Input } from '@angular/core';

@Component({
  selector: 'vm-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent {
  @Input() imagePath?: string;
  @Input() imageAlt?: string;
  @Input() layer?: string;
  @Input() preventOverflow?: boolean;

  get classes() {
    let imzClass = 'image';
    const preventOverflowClass = this.preventOverflow ? ' prevent-overflow' : '';

    if (this.layer !== undefined) {
      if (this.layer === 'modal') {
        imzClass = `${imzClass}-modal`;
      } else if (this.layer === 'single') {
        imzClass = `${imzClass}-single`;
      } else if (this.layer === 'single-image-comp') {
        imzClass = `${imzClass}-single-comp`;
      } else if (this.layer === 'single-image-border') {
        imzClass = `${imzClass}-single-border`;
      } else {
        imzClass = `${imzClass}-fluid`;
      }
    } else {
      imzClass = `${imzClass}-fluid`;
    }
    return imzClass + preventOverflowClass;
  }
}
